export var name = 'shortcut';
